<template>
  <VContainer>
    <VRow no-gutters justify="center">
      <VCol class="d-flex justify-center" :cols="!landscape ? 12 : 'auto'">
        <DemonstratorAvatar
          :demonstrator="demonstrator"
          :size="avatarSize"
          style="font-size:36px; position: relative; overflow: visible;"
        >
          <template v-if="!accountDemo && canClear">
            <VTooltip location="top" offset="-20">
              <template #activator="{ props: propsActivator }">
                <VChip class="hidden-md-and-down" color="secondary" data-testid="clear-demo" variant="flat" v-bind="propsActivator" @click="emits('change-demo')">
                  <VIcon :aria-help="$t('demo.label.clearTooltip')" style="margin-top:-2px">
                    {{ icons.mdiAccountRemove }}
                  </VIcon>
                </VChip>
              </template>
              <span class="text--primary"> {{ $t('demo.label.clearTooltip') }} </span>
            </VTooltip>
            <VChip class="hidden-lg-and-up" color="secondary" @click="emits('change-demo')">
              <VIcon :aria-help="$t('demo.label.clearTooltip')">
                {{ icons.mdiAccountRemove }}
              </VIcon>
            </VChip>
          </template>
        </DemonstratorAvatar>
      </VCol>
      <VCol :cols="!landscape ? 12 : 'auto'">
        <VRow no-gutters class="d-block">
          <VCol
            cols="12"
            :class="landscape ? 'text-left' : 'text-center'"
            class="pa-0 pt-4 font18 font-weight-bold text-left"
            data-testid="name"
          >
            {{ demonstratorName }}
          </VCol>
          <VCol
            :class="landscape ? 'text-left' : 'text-center'"
            class="pa-0 py-2 font12 text-greyedOut text-uppercase"
            data-testid="location"
          >
            {{ demonstratorAddress }}
          </VCol>
          <VCol
            v-if="showPersonalContact"
            :class="landscape ? 'text-left' : 'text-center'"
            class="pa-0 pt-2 font12"
            data-testid="phone"
            data-clarity-mask="True"
          >
            {{ demonstratorPhone }}
          </VCol>
          <VCol
            v-if="showPersonalContact"
            :class="landscape ? 'text-left' : 'text-center'"
            class="pa-0 font12 text-lowercase"
            data-testid="email"
            data-clarity-mask="True"
          >
            {{ demonstratorEmail }}
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script lang="ts" setup>
import { mdiAccountRemove } from '@mdi/js'
import type { Demonstrator } from '~/types/account'
import DemonstratorAvatar from '~/components/account/demonstrator/DemonstratorAvatar.vue'

const icons = { mdiAccountRemove }

interface Props {
  demonstrator: Demonstrator
  avatarSize?: number
  landscape?: boolean
  accountDemo?: boolean
  canClear?: boolean
  showPersonalContact?: boolean
  /** City and region only, as nuxt2's subscription-transfer preview shows them. */
  shortLocation?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  avatarSize: 76,
  landscape: false,
  accountDemo: false,
  canClear: true,
  showPersonalContact: false,
  shortLocation: false
})

const emits = defineEmits<{
  (e: 'change-demo'): void
}>()


const demonstratorName = computed(() => `${props.demonstrator.firstName} ${props.demonstrator.lastName}`)
const demonstratorAddress = computed(() => {
  const { city, suburb, region, county } = props.demonstrator
  return (props.shortLocation ? [city, region] : [city, suburb, region, county]).filter(Boolean).join(', ')
})
const demonstratorPhone = computed(() => {
  const country = props.demonstrator.country
  const phoneNumber = props.demonstrator.phoneNumber
  if (!phoneNumber) { return }
  // phone numbers for us and ca are stored with no formatting
  if (country.toLowerCase() === 'us' || country.toLowerCase() === 'ca') {
    return phoneNumber.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1-$2-$3')
  }
  return phoneNumber
})
const demonstratorEmail = computed(() => props.demonstrator.email)
</script>
<style lang="scss" scoped>
  .v-chip {
    border-radius: 25px;
    padding: 5px;
    position: absolute;
    right: 10px;
    height: 34px;
    width: 34px;
    top: 0;
  }
  .v-icon {
    height: 22px;
    width: 22px;
  }
  .menuable__content__active {
    border: 1px solid black;
    background-color: white;
    border-radius: 0px;
    opacity: 1;
  }
</style>
